import { render, staticRenderFns } from "./openCamera.vue?vue&type=template&id=4127847e&scoped=true"
import script from "./openCamera.vue?vue&type=script&lang=js"
export * from "./openCamera.vue?vue&type=script&lang=js"
import style0 from "./openCamera.vue?vue&type=style&index=0&id=4127847e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4127847e",
  null
  
)

export default component.exports